"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _filter = _interopRequireDefault(require("lodash/filter"));
var _keyBy = _interopRequireDefault(require("lodash/keyBy"));
var types = _interopRequireWildcard(require("./types"));
var _object = require("../../utils/object");
var _types2 = require("../feedItems/types");
var _types3 = require("../session/types");
var _types4 = require("../activities/types");
var _types5 = require("../notifications/types");
var _types6 = require("../rooms/types");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  users: {},
  anchors: {},
  feeds: {},
  feedItems: {},
  feedMembers: {},
  invitations: {},
  notifications: {},
  activities: {},
  rooms: {},
  contacts: {}
};
var entitiesReducer = function entitiesReducer() {
  var _state$activities, _state$notifications;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _cloneDeep.default)(initialState);
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var feedItems = {};
  switch (action.type) {
    case types.PUT_ENTITY:
      return _objectSpread(_objectSpread({}, state), {}, {
        feedItems: _objectSpread(_objectSpread({}, state.feedItems), {}, {
          [action.payload.id]: _objectSpread({}, action.payload)
        })
      });
    case _types2.REQUEST_DELETE_LOCAL_FEED_ITEMS:
      Object.keys(state.feedItems).forEach(_feedItem => {
        if (!action._feedItems.includes(_feedItem)) {
          feedItems[_feedItem] = state.feedItems[_feedItem];
        }
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        feedItems: _objectSpread({}, state.feedItems)
      });
    case _types2.REMOVE_FEED_ITEMS:
      action._feedItems.forEach(_feedItem => delete state.feedItems[_feedItem]);
      return _objectSpread(_objectSpread({}, state), {}, {
        feedItems: _objectSpread({}, state.feedItems)
      });
    case _types2.PATCH_LOCAL_FEED_ITEM:
      return _objectSpread(_objectSpread({}, state), {}, {
        feedItems: _objectSpread(_objectSpread({}, state.feedItems), {}, {
          [action._feedItem]: _objectSpread(_objectSpread({}, state.feedItems[action._feedItem]), action.payload)
        })
      });
    case _types4.REMOVE_ACTIVITY_FROM_ENTITIES:
      (_state$activities = state.activities) === null || _state$activities === void 0 || delete _state$activities[action._activity];
      return _objectSpread(_objectSpread({}, state), {}, {
        activities: _objectSpread({}, state.activities)
      });
    case _types5.REMOVE_NOTIFICATION_FROM_ENTITIES:
      (_state$notifications = state.notifications) === null || _state$notifications === void 0 || delete _state$notifications[action._notification];
      return _objectSpread(_objectSpread({}, state), {}, {
        notifications: _objectSpread({}, state.notifications)
      });
    case _types5.SET_NOTIFICATION_TO_READ_BY_CATEGORY:
      Object.keys(state.notifications).forEach(_notif => {
        if (action.category === state.notifications[_notif].category) {
          state.notifications[_notif].read = true;
        }
      });
      return state;
    case _types6.SET_ROOMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        rooms: (0, _keyBy.default)((0, _filter.default)(state.rooms, (room, id) => action._rooms.includes(id)), 'id')
      });
    case _types6.REMOVE_ROOM:
      delete state.rooms[action._room];
      return _objectSpread({}, state);
    case _types2.SET_LAST_FILE_FEED_ITEMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        lastFileFeedItems: (0, _keyBy.default)((0, _filter.default)(state.lastFileFeedItems, (item, id) => action._items.includes(id)), 'id')
      });
    case types.MERGE_ENTITIES:
      return (0, _object.mergeEntities)(state, action.payload);
    case _types3.PURGE_SESSION:
      return (0, _cloneDeep.default)(initialState);
    default:
      return state;
  }
};
var _default = exports.default = entitiesReducer;
module.exports = exports.default;